import { useRouteLoaderData } from "react-router-dom"
import { Outlet } from "react-router-dom"
import Header from "../layout/main/Header"

export default function DashboardLayout() {
  const { userEntity } = useRouteLoaderData("dashboardComponent")

  return (
    <div className="m-0 p-0">
      <Header />
      <Outlet />
    </div>
  )
}
